import React from 'react';
import SEO from '../components/SEO';
import ScrollToTop from '../components/ScrollToTop';
// Import your images here
// import MachakosElitesImg from '../assets/images/machakos_elites.webp';

const YouthLeadershipAndMentorshipPage = () => {
  const steeringTeam = [
    { name: "Stanly Musau", role: "Team Leader" },
    { name: "Faith Mbithe", role: "Team Member" },
    { name: "Griton Mwanzia", role: "Team Member" },
    { name: "Patrick Mwanzia", role: "Team Member" },
    { name: "Alex Mavuti", role: "Team Member" },
    { name: "Peter Wambua", role: "Team Member" },
    { name: "Kelvin Kasomo", role: "Team Member" }
  ];

  return (
    <>
      <SEO 
        title="Machakos Elites - Empowering Youth, Inspiring Change"
        description="Machakos Elites is an independent, organized youth group committed to shaping the future of Machakos County through meaningful dialogue, mentorship, and awareness creation."
        keywords="Machakos Elites, Youth empowerment Machakos, Youth leadership Kenya, Machakos County youth, Civic engagement Kenya, Youth mentorship programs, Community development Kenya, Youth forums Machakos, Leadership development, Stanly Musau, Faith Mbithe, Griton Mwanzia, Patrick Mwanzia, Alex Mavuti, Peter Wambua, Kelvin Kasomo, Youth dialogue Kenya, Mental health awareness, Gender equality Kenya, Climate action youth, Entrepreneurship training, Public speaking training, Advocacy skills, Project management training"
      />
      <ScrollToTop />
      
      <div className="container">
        <div className="text-center mb-5">
          <h1 className="text1">Youth Leadership and Empowerment Hub</h1>
          <h2 className="display-4 text-primary fw-bold">Machakos Elites</h2>
          <p className="lead fst-italic">"Empowering Youth, Inspiring Change."</p>
        </div>

        {/* About Section */}
        <div className="row mb-5">
          <div className="col-12">
            <h3 className="h2 mb-4">About Machakos Elites</h3>
            <p className="lead">
              Machakos Elites is an independent, organized youth group committed to shaping the future of Machakos County through meaningful dialogue, mentorship, and awareness creation. We believe that youth are not just leaders of tomorrow — they are agents of change today.
            </p>
            <p className="lead">
              Our organization provides a safe and engaging space where young people can share ideas, learn from one another, and gain the skills needed to actively participate in community development.
            </p>
          </div>
        </div>

        {/* Mission and Vision */}
        <div className="row mb-5">
          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body">
                <h4 className="card-title text-primary">Our Mission</h4>
                <p className="card-text">
                  To empower and mentor the youth of Machakos County by fostering leadership, encouraging civic participation, and promoting solutions for a thriving, inclusive community.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body">
                <h4 className="card-title text-primary">Our Vision</h4>
                <p className="card-text">
                  A community where every young person is inspired, informed, and equipped to lead positive change.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div className="mb-5">
        <h3 className="h2 mb-4 text-center">Core Values</h3>
        <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="card h-100 text-center text-white shadow-sm border-0" 
                style={{ backgroundColor: 'var(--primary-color)' }}>
                <div className="card-body p-4">
                <h5 className="fw-bold mb-3">Integrity</h5>
                <p className="mb-0">
                    We lead by example and uphold honesty in all our engagements, 
                    building trust through transparent and ethical actions.
                </p>
                </div>
            </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="card h-100 text-center text-white shadow-sm border-0" 
                style={{ backgroundColor: 'var(--good-health-and-well-being)' }}>
                <div className="card-body p-4">
                <h5 className="fw-bold mb-3">Inclusivity</h5>
                <p className="mb-0">
                    Every youth voice matters. We embrace diversity and create spaces 
                    where all young people feel valued and heard.
                </p>
                </div>
            </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="card h-100 text-center text-white shadow-sm border-0" 
                style={{ backgroundColor: 'var(--gender-equality-original)' }}>
                <div className="card-body p-4">
                <h5 className="fw-bold mb-3">Innovation</h5>
                <p className="mb-0">
                    Creative solutions for community challenges. We encourage fresh 
                    thinking and innovative approaches to problem-solving.
                </p>
                </div>
            </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="card h-100 text-center text-white shadow-sm border-0" 
                style={{ backgroundColor: 'var(--decent-work-and-economic-growth)' }}>
                <div className="card-body p-4">
                <h5 className="fw-bold mb-3">Collaboration</h5>
                <p className="mb-0">
                    Working together for lasting impact. We believe in the power of 
                    teamwork and partnership to achieve meaningful change.
                </p>
                </div>
            </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="card h-100 text-center text-white shadow-sm border-0" 
                style={{ backgroundColor: 'var(--climate-action)' }}>
                <div className="card-body p-4">
                <h5 className="fw-bold mb-3">Service</h5>
                <p className="mb-0">
                    Commitment to uplifting society. We dedicate ourselves to serving 
                    our community and creating positive social impact.
                </p>
                </div>
            </div>
            </div>
        </div>
        </div>


        {/* What We Do */}
        <div className="mb-5">
          <h3 className="h2 mb-4">What We Do</h3>
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-start border-4 border-primary">
                <div className="card-body">
                  <h5 className="card-title">Dialogue & Civic Engagement</h5>
                  <p className="card-text">
                    We host youth forums and community dialogues that tackle pressing issues such as education, employment, mental health, gender equality, and civic responsibility.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-start border-4 border-success">
                <div className="card-body">
                  <h5 className="card-title">Mentorship Programs</h5>
                  <p className="card-text">
                    As professionals and youth leaders, we support young people to nurture leadership skills, career development, and personal growth.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-start border-4 border-warning">
                <div className="card-body">
                  <h5 className="card-title">Awareness Campaigns</h5>
                  <p className="card-text">
                    Through workshops, social media, and events, we create awareness on key issues including reproductive health, governance, climate action, and entrepreneurship.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-start border-4 border-info">
                <div className="card-body">
                  <h5 className="card-title">Capacity Building</h5>
                  <p className="card-text">
                    We provide training sessions on communication, advocacy, project management, and public speaking to equip youth with practical skills for impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Steering Team */}
        <div className="mb-5">
          <h3 className="h2 mb-4">The Steering Team</h3>
          <div className="row">
            {steeringTeam.map((member, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div className="card text-center shadow-sm h-100">
                  <div className="card-body">
                    <h6 className="card-title text-primary">{member.name}</h6>
                    <small className="text-muted">{member.role}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-primary text-white p-5 rounded mb-5">
          <h3>Join Us in Making a Difference</h3>
          <p className="lead mb-4">
            Together, we can empower youth and inspire positive change in Machakos County and beyond.
          </p>
          <p className="fw-bold">
            "Youth are not just leaders of tomorrow — they are agents of change today!"
          </p>
        </div>
      </div>
    </>
  )
}

export default YouthLeadershipAndMentorshipPage;